import {z} from 'zod';

import {reportFiltersSchema} from './ReportFiltersSchema';

export const revenueByMonthSchema = z.object({
  month: z.string(),
  labourRevenue: z.number(),
  materialRevenue: z.number(),
  dmmRevenue: z.number(),
  totalRevenue: z.number(),
});

export type RevenueByMonth = z.infer<typeof revenueByMonthSchema>;

export const revenueSummarySchema = revenueByMonthSchema.omit({month: true});

export type RevenueSummary = z.infer<typeof revenueSummarySchema>;

export const revenueByMonthResponseSchema = z.object({
  data: z.array(revenueByMonthSchema),
  summary: revenueSummarySchema,
  filters: reportFiltersSchema,
});

export type RevenueByMonthResponse = z.infer<typeof revenueByMonthResponseSchema>;
